import { Component } from '@theme/component';

/**
 * Vertical accordion list. Only one item is open at a time; opening an item
 * closes any other open item. Height animation and icon swap are handled in
 * CSS (grid-template-rows + [aria-expanded]/[aria-hidden] selectors) so this
 * only needs to flip the ARIA state.
 *
 * @typedef {Object} Refs
 * @property {HTMLButtonElement[]} triggers
 * @property {HTMLElement[]} panels
 *
 * @extends {Component<Refs>}
 */
export class ExpandableDetails extends Component {
  requiredRefs = ['triggers', 'panels'];

  /**
   * @param {Event} event
   */
  toggleItem(event) {
    const trigger = /** @type {HTMLButtonElement} */ (event.target);
    const index = this.refs.triggers.indexOf(trigger);
    if (index === -1) return;

    const opening = trigger.getAttribute('aria-expanded') !== 'true';

    this.refs.triggers.forEach((itemTrigger, i) => {
      const panel = this.refs.panels[i];
      const open = opening && i === index;

      itemTrigger.setAttribute('aria-expanded', String(open));
      panel.setAttribute('aria-hidden', String(!open));
    });
  }
}

if (!customElements.get('expandable-details-component')) {
  customElements.define('expandable-details-component', ExpandableDetails);
}
